// src/lib/kinema/core/tools/GestureOverride.ts
export class GestureOverrideManager {
  private activeIds = new Set<string>();

  begin(layerId: string): void {
    this.activeIds.add(layerId);
  }

  isActive(layerId: string): boolean {
    return this.activeIds.has(layerId);
  }

  end(layerId: string): void {
    this.activeIds.delete(layerId);
  }
}
